/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PromptFiltersResponse {
    getFixupPrototypeFunction() { return PromptFiltersResponse.fixupPrototype; }

    static newInstance(model: Partial<PromptFiltersResponse>): PromptFiltersResponse {
        let obj = Object.assign(new PromptFiltersResponse(), model);
        PromptFiltersResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PromptFiltersResponse>): PromptFiltersResponse {
        if (!model) return null;
        return PromptFiltersResponse.newInstance(<PromptFiltersResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PromptFiltersResponse) {
        if (!obj) return;

        models.PromptFiltersResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PromptFiltersResponse): boolean {
        Object.setPrototypeOf(obj, PromptFiltersResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.tags) {
            for (let val of this.tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * List of tag key/value pairs
     */
    tags: Array<models.KeyValuePair>;

}
